<template>
  <span>
    <v-btn @click="handleShowForm">
      Recalculate all cases anomalies
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline">Recalculate all cases anomalies</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit"
                 :disabled="!isSubmitEnabled"
                 :loading="requestInProgress">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import {mapActions} from "vuex";
  import {notificationService} from "../../application";

  function getDefaultFormData() {
    return {
    }
  }

  export default {
    name: 're-calculate-all-cases-anomalies-form',
    data() {
      return {
        form: getDefaultFormData(),
        showModal: false,
        isValid: false,
        requestInProgress: false,
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        const valid = this.isValid;
        if (!valid) {
          return false
        }

        if (this.$refs.form && !this.$refs.form.validate()) {
          return false
        }

        return true
      }
    },
    methods: {
      ...mapActions({
        runRequest: 'caseAnomaliesReCalculateAllCasesAnomalies',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.isSubmitEnabled) {
          return
        }

        const request = {
        };

        this.requestInProgress = true;

        this
          .runRequest(request)
          .then(() => {
            this.requestInProgress = false;
            notificationService.info('Operation success');
            this.resetForm();
            this.showModal = false
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.caseInfo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/case-anomalies/ReCalculateAllCasesAnomaliesForm.vue